import { Select, Option, OptionGroup } from "@flightpath/coreui/dist/ui/_forms/Select";

let s = {
  Select,
  Option,
  OptionGroup
};

export default s;
